import { OPTIMISATION_THUMBS_INTROS_FINALISATION_TABLES_INITIAL_STATE } from "@/models/options";

const v13 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        optimisationThumbsTable: {
          ...OPTIMISATION_THUMBS_INTROS_FINALISATION_TABLES_INITIAL_STATE,
        },
        optimisationIntrosTable: {
          ...OPTIMISATION_THUMBS_INTROS_FINALISATION_TABLES_INITIAL_STATE,
        },
        optimisationFinalisationTable: {
          ...OPTIMISATION_THUMBS_INTROS_FINALISATION_TABLES_INITIAL_STATE,
        },
        optimisationTipsTable: {
          "Variation Name": true,
          "Scene Duration": true,
          Views: true,
          Thumb: true,
          CTR: true,
          "30s Reach": true,
          "e30s Reach": true,
          "e45s Reach": true,
          "e60s Reach": true,
          "e120s Reach": true,
          "25% Reach": true,
          "50% Reach": true,
          "75% Reach": true,
          "100% Reach": true,
          "Final Value": true,
          Channel: true,
          "Audience Channels": false,
          "Max CPV": true,
          "Campaign Budget": false,
          "Drop Visualization": true,
          Drop: true,
        },
        optimisationSequenceTable: {
          "Variation Name": true,
          Views: true,
          Thumb: true,
          CTR: true,
          "Watchtime (s)": true,
          "8 min Reach": true,
          "e8 min Reach": true,
          "Final Value": true,
          eYTV: true,
          Channel: true,
          "Audience Channels": false,
          "Max CPV": true,
          "Campaign Budget": false,
          "Drop Visualization": true,
          Drop: true,
        },
      },
    },
  };
};

export default v13;
